/**
 * True when a scroll container is within `px` of the given edge — the trigger
 * for fetching the next page of an infinite list.
 *
 * ponytail: a plain scroll handler rather than IntersectionObserver. One
 * function, no observer lifecycle, and it works in jsdom without a stub.
 */
export function nearEdge(
  el: HTMLElement,
  edge: 'top' | 'bottom',
  px = 120
): boolean {
  // A container with nothing to scroll sits at BOTH edges at once. Reading
  // that as "the user scrolled to the end" would page in the entire list the
  // moment it renders.
  if (el.scrollHeight <= el.clientHeight) return false;
  if (edge === 'top') return el.scrollTop <= px;
  return el.scrollHeight - el.scrollTop - el.clientHeight <= px;
}
